import { Slider } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { WHITE } from 'theme/palette';

/**
 * Custom slider for timeline layers (e.g. radar, lightning, and smoke).
 *
 * Distinct from WatchDutySlider - uses a differently styled thumb and track.
 * Future consideration: consolidate slider designs across cameras, progression models, and timeline layers.
 */
export const WatchDutyTimelineSlider = withStyles(Slider, (theme) => ({
  root: {
    height: 35,
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
    pointerEvents: 'auto',
  },
  thumb: {
    width: 20,
    height: 20,
    // Above the SliderNowMarker (zIndex: 1), which itself sits above the track/rail.
    zIndex: 2,
    backgroundColor: theme.palette.brand[500],
    backgroundClip: 'padding-box',
    border: `4px solid ${WHITE}`,
    '&:before': {
      boxShadow: 'none',
    },
    boxShadow: theme.shadows[1],
    transition: 'left 200ms linear',
  },
  track: {
    height: 8,
    borderRadius: 4,
    border: 0,
    transition: 'width 200ms linear',
  },
  rail: {
    height: 8,
    borderRadius: 4,
    border: 0,
    color: theme.palette.warmGrey[500],
    opacity: 1, // Override the default opacity
  },
  mark: {
    width: 2,
    height: 2,
    borderRadius: 2,
    backgroundColor: theme.palette.grey[900],
  },
  markActive: {
    backgroundColor: theme.palette.grey[900],
  },
}));
